var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.filterColumns,"group-actions":_vm.groupActions,"single-actions":!_vm.hiddenSingleActions && _vm.singleActions,"export-data-options":_vm.exportDataOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }